import { render, staticRenderFns } from "./widget_alerts_summary.vue?vue&type=template&id=51da3e94&"
import script from "./widget_alerts_summary.vue?vue&type=script&lang=js&"
export * from "./widget_alerts_summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports